import { InternalMessageBus, InternalMessageBusMessage, InternalMessageBusChannels } from "sb-resp-lib";
import { action, observable } from "mobx";
import { LiveMasterEventLegacy } from "sb-resp-lib";
// this class has ignore flag because action and observable implement interfaces
// and testing typescript interfaces is not possible with jest
// https://github.com/kulshekhar/ts-jest/issues/378
// i believe jest expects action.d.ts and observable.d.ts to be covered with tests as well as this file
// and that's why although this class is fully covered test coverage for branches without the flag is 33.3%
/* istanbul ignore next */
export class Retriever {
    internalMessageBus: InternalMessageBus;
    @observable liveMasterEvent: LiveMasterEventLegacy;
    backgroundImg: string;

    constructor(messageBus: InternalMessageBus, backgroundImg: string) {
        this.internalMessageBus = messageBus;
        this.liveMasterEvent = {} as LiveMasterEventLegacy;
        this.backgroundImg = backgroundImg;
    }

    activate() {
        this.internalMessageBus.on(InternalMessageBusChannels.legacy.eventView.event.update, this.updateData);
    }

    deactivate() {
        this.internalMessageBus.off(InternalMessageBusChannels.legacy.eventView.event.update, this.updateData);
    }

    @action.bound updateData(message: InternalMessageBusMessage<LiveMasterEventLegacy>) {
        this.liveMasterEvent = message.data[0];
    }
}